const COUNTRIES = [
  {
    code: "ad",
    name: {
      fr: "Andorre",
      en: "Andorra",
      es: "Andorra",
      ca: "Andorra",
      it: "Andorra",
      de: "Andorra",
      nl: "Andorra",
    },
  },
  {
    code: "ae",
    name: {
      fr: "Emirats Arabes Unis",
      en: "U.A.Emirates",
      es: "U.A.Emirates",
      ca: "U.A.Emirates",
      it: "U.A.Emirates",
      de: "Vereinigte Arabische Emirate",
      nl: "Vereinigte Arabische Emirate",
    },
  },
  {
    code: "af",
    name: {
      fr: "Afghanistan",
      en: "Afghanistan",
      es: "Afghanistan",
      ca: "Afghanistan",
      it: "Afghanistan",
      de: "Afghanistan",
      nl: "Afghanistan",
    },
  },
  {
    code: "ag",
    name: {
      fr: "Antigua et Barbuda",
      en: "Antigua and Barbuda",
      es: "Antigua and Barbuda",
      ca: "Antigua and Barbuda",
      it: "Antigua e Barbuda",
      de: "Antigua und Barbuda",
      nl: "Antigua und Barbuda",
    },
  },
  {
    code: "ai",
    name: {
      fr: "Anguilla",
      en: "Anguilla",
      es: "Anguilla",
      ca: "Anguilla",
      it: "Anguilla",
      de: "Anguilla",
      nl: "Anguilla",
    },
  },
  {
    code: "al",
    name: {
      fr: "Albanie",
      en: "Albania",
      es: "Albania",
      ca: "Albania",
      it: "Albania",
      de: "Albanien",
      nl: "Albanien",
    },
  },
  {
    code: "am",
    name: {
      fr: "Arménie",
      en: "Armenia",
      es: "Armenia",
      ca: "Armenia",
      it: "Armenia",
      de: "Armenien",
      nl: "Armenien",
    },
  },
  {
    code: "ao",
    name: {
      fr: "Angola",
      en: "Angola",
      es: "Angola",
      ca: "Angola",
      it: "Angola",
      de: "Angola",
      nl: "Angola",
    },
  },
  {
    code: "ar",
    name: {
      fr: "Argentine",
      en: "Argentina",
      es: "Argentina",
      ca: "Argentina",
      it: "Argentina",
      de: "Argentinien",
      nl: "Argentinien",
    },
  },
  {
    code: "as",
    name: {
      fr: "Samoa Américaines",
      en: "American Samoa",
      es: "American Samoa",
      ca: "American Samoa",
      it: "American Samoa",
      de: "Amerikanisch-Samoa",
      nl: "Amerikanisch-Samoa",
    },
  },
  {
    code: "at",
    name: {
      fr: "Autriche",
      en: "Austria",
      es: "Austria",
      ca: "Austria",
      it: "Austria",
      de: "Österreich",
      nl: "Österreich",
    },
  },
  {
    code: "au",
    name: {
      fr: "Australie",
      en: "Australia",
      es: "Australia",
      ca: "Australia",
      it: "Australia",
      de: "Australien",
      nl: "Australien",
    },
  },
  {
    code: "aw",
    name: {
      fr: "Aruba",
      en: "Aruba",
      es: "Aruba",
      ca: "Aruba",
      it: "Aruba",
      de: "Aruba",
      nl: "Aruba",
    },
  },
  {
    code: "az",
    name: {
      fr: "Azerbaïdjan",
      en: "Azerbaijan",
      es: "Azerbaijan",
      ca: "Azerbaijan",
      it: "Azerbaijan",
      de: "Aserbaidschan",
      nl: "Aserbaidschan",
    },
  },
  {
    code: "ba",
    name: {
      fr: "Bosnie",
      en: "Bosnia",
      es: "Bosnia",
      ca: "Bosnia",
      it: "Bosnia",
      de: "Bosnien-Herzegowina",
      nl: "Bosnien-Herzegowina",
    },
  },
  {
    code: "bb",
    name: {
      fr: "Barbade",
      en: "Barbados",
      es: "Barbados",
      ca: "Barbados",
      it: "Barbados",
      de: "Barbados",
      nl: "Barbados",
    },
  },
  {
    code: "bd",
    name: {
      fr: "Bangladesh",
      en: "Bangladesh",
      es: "Bangladesh",
      ca: "Bangladesh",
      it: "Bangladesh",
      de: "Bangladesh",
      nl: "Bangladesh",
    },
  },
  {
    code: "be",
    name: {
      fr: "Belgique",
      en: "Belgium",
      es: "Belgium",
      ca: "Belgium",
      it: "Belgio",
      de: "Belgien",
      nl: "Belgie",
    },
  },
  {
    code: "bf",
    name: {
      fr: "Burkina Faso",
      en: "Burkina Faso",
      es: "Burkina Faso",
      ca: "Burkina Faso",
      it: "Burkina Faso",
      de: "Burkina Faso",
      nl: "Burkina Faso",
    },
  },
  {
    code: "bg",
    name: {
      fr: "Bulgarie",
      en: "Bulgaria",
      es: "Bulgaria",
      ca: "Bulgaria",
      it: "Bulgaria",
      de: "Bulgarien",
      nl: "Bulgarien",
    },
  },
  {
    code: "bh",
    name: {
      fr: "Barhein",
      en: "Bahrain",
      es: "Bahrain",
      ca: "Bahrain",
      it: "Bahrain",
      de: "Bahrain",
      nl: "Bahrain",
    },
  },
  {
    code: "bi",
    name: {
      fr: "Burundi",
      en: "Burundi",
      es: "Burundi",
      ca: "Burundi",
      it: "Burundi",
      de: "Burundi",
      nl: "Burundi",
    },
  },
  {
    code: "bj",
    name: {
      fr: "Bénin",
      en: "Benin",
      es: "Benin",
      ca: "Benin",
      it: "Benin",
      de: "Benin",
      nl: "Benin",
    },
  },
  {
    code: "bm",
    name: {
      fr: "Bermudes",
      en: "Bermuda",
      es: "Bermuda",
      ca: "Bermuda",
      it: "Bermuda",
      de: "Bermuda",
      nl: "Bermuda",
    },
  },
  {
    code: "bn",
    name: {
      fr: "Brunei",
      en: "Brunei",
      es: "Brunei",
      ca: "Brunei",
      it: "Brunei",
      de: "Brunei",
      nl: "Brunei",
    },
  },
  {
    code: "bo",
    name: {
      fr: "Bolivie",
      en: "Bolivia",
      es: "Bolivia",
      ca: "Bolivia",
      it: "Bolivia",
      de: "Bolivien",
      nl: "Bolivien",
    },
  },
  {
    code: "bq",
    name: {
      fr: "Pays-Bas Caribéens",
      en: "Caribbean Netherlands",
      es: "Caribbean Netherlands",
      ca: "Caribbean Netherlands",
      it: "Caribbean Netherlands",
      de: "Caribbean Netherlands",
      nl: "Caribbean Netherlands",
    },
  },
  {
    code: "br",
    name: {
      fr: "Brésil",
      en: "Brazil",
      es: "Brazil",
      ca: "Brazil",
      it: "Brasile",
      de: "Brasilien",
      nl: "Brasilien",
    },
  },
  {
    code: "bs",
    name: {
      fr: "Bahamas",
      en: "Bahamas",
      es: "Bahamas",
      ca: "Bahamas",
      it: "Bahamas",
      de: "Bahamas",
      nl: "Bahamas",
    },
  },
  {
    code: "bt",
    name: {
      fr: "Bhoutan",
      en: "Bhutan",
      es: "Bhutan",
      ca: "Bhutan",
      it: "Bhutan",
      de: "Bhutan",
      nl: "Bhutan",
    },
  },
  {
    code: "bw",
    name: {
      fr: "Botswana",
      en: "Botswana",
      es: "Botswana",
      ca: "Botswana",
      it: "Botswana",
      de: "Botswana",
      nl: "Botswana",
    },
  },
  {
    code: "by",
    name: {
      fr: "Bélarus",
      en: "Belarus",
      es: "Belarus",
      ca: "Belarus",
      it: "Bielorussia",
      de: "Weissrussland",
      nl: "Weissrussland",
    },
  },
  {
    code: "bz",
    name: {
      fr: "Belize",
      en: "Belize",
      es: "Belize",
      ca: "Belize",
      it: "Belize",
      de: "Belize",
      nl: "Belize",
    },
  },
  {
    code: "ca",
    name: {
      fr: "Canada",
      en: "Canada",
      es: "Canada",
      ca: "Canada",
      it: "Canada",
      de: "Kanada",
      nl: "Kanada",
    },
  },
  {
    code: "cd",
    name: {
      fr: "Congo (République Démocratique du)",
      en: "Congo ( Democratic Republic of)",
      es: "Congo ( Democratic Republic of)",
      ca: "Congo ( Democratic Republic of)",
      it: "Congo (Repubblica Democratica del)",
      de: "Demokratische Republik Kongo",
      nl: "Demokratische Republik Kongo",
    },
  },
  {
    code: "cf",
    name: {
      fr: "République d'Afrique Centrale",
      en: "Central African Republic",
      es: "Central African Republic",
      ca: "Central African Republic",
      it: "Repubblica Centrafricana",
      de: "Zentralafrikanische Republik",
      nl: "Zentralafrikanische Republik",
    },
  },
  {
    code: "cg",
    name: {
      fr: "Congo (République du)",
      en: "Congo (Republic of)",
      es: "Congo (Republic of)",
      ca: "Congo (Republic of)",
      it: "Congo (Repubblica del)",
      de: "Republik Kongo",
      nl: "Republik Kongo",
    },
  },
  {
    code: "ch",
    name: {
      fr: "Suisse",
      en: "Switzerland",
      es: "Switzerland",
      ca: "Switzerland",
      it: "Svizzera",
      de: "Schweiz",
      nl: "Schweiz",
    },
  },
  {
    code: "ci",
    name: {
      fr: "Côte d'Ivoire",
      en: "Ivory Coast",
      es: "Ivory Coast",
      ca: "Ivory Coast",
      it: "Costa d'Avorio",
      de: "Elfenbeinküste",
      nl: "Elfenbeinküste",
    },
  },
  {
    code: "cl",
    name: {
      fr: "Chili",
      en: "Chile",
      es: "Chile",
      ca: "Chile",
      it: "Cile",
      de: "Chile",
      nl: "Chile",
    },
  },
  {
    code: "cm",
    name: {
      fr: "Cameroun",
      en: "Cameroon",
      es: "Cameroon",
      ca: "Cameroon",
      it: "Cameroon",
      de: "Kamerun",
      nl: "Kamerun",
    },
  },
  {
    code: "cn",
    name: {
      fr: "Chine",
      en: "China",
      es: "China",
      ca: "China",
      it: "Cina",
      de: "China",
      nl: "China",
    },
  },
  {
    code: "co",
    name: {
      fr: "Colombie",
      en: "Colombia",
      es: "Colombia",
      ca: "Colombia",
      it: "Colombia",
      de: "Kolumbien",
      nl: "Kolumbien",
    },
  },
  {
    code: "cr",
    name: {
      fr: "Costa Rica",
      en: "Costa Rica",
      es: "Costa Rica",
      ca: "Costa Rica",
      it: "Costa Rica",
      de: "Costa Rica",
      nl: "Costa Rica",
    },
  },
  {
    code: "cu",
    name: {
      fr: "Cuba",
      en: "Cuba",
      es: "Cuba",
      ca: "Cuba",
      it: "Cuba",
      de: "Kuba",
      nl: "Kuba",
    },
  },
  {
    code: "cv",
    name: {
      fr: "Cap Vert",
      en: "Cape Verde",
      es: "Cape Verde",
      ca: "Cape Verde",
      it: "Capo Verde",
      de: "Kap Verde",
      nl: "Kap Verde",
    },
  },
  {
    code: "cy",
    name: {
      fr: "Chypre",
      en: "Cyprus",
      es: "Cyprus",
      ca: "Cyprus",
      it: "Cipro",
      de: "Zypern",
      nl: "Zypern",
    },
  },
  {
    code: "cz",
    name: {
      fr: "Tchèque (République)",
      en: "Czech Republic",
      es: "Czech Republic",
      ca: "Czech Republic",
      it: "Repubblica Ceca",
      de: "Tschechische Republik",
      nl: "Tschechische Republik",
    },
  },
  {
    code: "de",
    name: {
      fr: "Allemagne",
      en: "Germany",
      es: "Germany",
      ca: "Germany",
      it: "Germania",
      de: "Deutschland",
      nl: "Deutschland",
    },
  },
  {
    code: "dj",
    name: {
      fr: "Djibouti",
      en: "Djibouti",
      es: "Djibouti",
      ca: "Djibouti",
      it: "Gibuti",
      de: "Djibouti",
      nl: "Djibouti",
    },
  },
  {
    code: "dk",
    name: {
      fr: "Danemark",
      en: "Denmark",
      es: "Denmark",
      ca: "Denmark",
      it: "Danimarca",
      de: "Dänemark",
      nl: "Dänemark",
    },
  },
  {
    code: "dm",
    name: {
      fr: "Dominique",
      en: "Dominique",
      es: "Dominique",
      ca: "Dominique",
      it: "Dominique",
      de: "Dominica",
      nl: "Dominica",
    },
  },
  {
    code: "do",
    name: {
      fr: "République Dominicaine",
      en: "Dominican Republic",
      es: "Dominican Republic",
      ca: "Dominican Republic",
      it: "Repubblica Dominicana",
      de: "Dominikanische Republik",
      nl: "Dominikanische Republik",
    },
  },
  {
    code: "dz",
    name: {
      fr: "Algérie",
      en: "Algeria",
      es: "Algeria",
      ca: "Algeria",
      it: "Algeria",
      de: "Algerien",
      nl: "Algerien",
    },
  },
  {
    code: "ec",
    name: {
      fr: "Equateur",
      en: "Ecuador",
      es: "Ecuador",
      ca: "Ecuador",
      it: "Ecuador",
      de: "Ecuador",
      nl: "Ecuador",
    },
  },
  {
    code: "ee",
    name: {
      fr: "Estonie",
      en: "Estonia",
      es: "Estonia",
      ca: "Estonia",
      it: "Estonia",
      de: "Estland",
      nl: "Estland",
    },
  },
  {
    code: "eg",
    name: {
      fr: "Egypte",
      en: "Egypt",
      es: "Egypt",
      ca: "Egypt",
      it: "Egitto",
      de: "Ägypten",
      nl: "Ägypten",
    },
  },
  {
    code: "eh",
    name: {
      fr: "Sahara Occidental",
      en: "Western Sahara",
      es: "Western Sahara",
      ca: "Western Sahara",
      it: "Sahara Occidentale",
      de: "Westsahara",
      nl: "Westsahara",
    },
  },
  {
    code: "er",
    name: {
      fr: "Erythrée",
      en: "Eritrea",
      es: "Eritrea",
      ca: "Eritrea",
      it: "Eritrea",
      de: "Eritrea",
      nl: "Eritrea",
    },
  },
  {
    code: "es",
    name: {
      fr: "Espagne",
      en: "Spain",
      es: "Spain",
      ca: "Spain",
      it: "Spagna",
      de: "Spanien",
      nl: "Spanien",
    },
  },
  {
    code: "et",
    name: {
      fr: "Ethiopie",
      en: "Ethiopia",
      es: "Ethiopia",
      ca: "Ethiopia",
      it: "Etiopia",
      de: "Äthiopien",
      nl: "Äthiopien",
    },
  },
  {
    code: "fi",
    name: {
      fr: "Finlande",
      en: "Finland",
      es: "Finland",
      ca: "Finland",
      it: "Finlandia",
      de: "Finnland",
      nl: "Finnland",
    },
  },
  {
    code: "fj",
    name: {
      fr: "Fidji",
      en: "Fiji",
      es: "Fiji",
      ca: "Fiji",
      it: "Fiji",
      de: "Fidschi",
      nl: "Fidschi",
    },
  },
  {
    code: "fk",
    name: {
      fr: "Falkland (Iles)",
      en: "Falkland Islands",
      es: "Falkland Islands",
      ca: "Falkland Islands",
      it: "Isole Falkland",
      de: "Falkland-Inseln",
      nl: "Falkland-Inseln",
    },
  },
  {
    code: "fm",
    name: {
      fr: "Etats Fédérés de Micronésie",
      en: "Micronesia (Federated States of)",
      es: "Micronesia (Federated States of)",
      ca: "Micronesia (Federated States of)",
      it: "Micronesia (Stati Federati di)",
      de: "Micronesien",
      nl: "Micronesien",
    },
  },
  {
    code: "fr",
    name: {
      fr: "France (métropolitaine)",
      en: "France (continental)",
      es: "France (continental)",
      ca: "França metropolitana",
      it: "Francia (continentale)",
      de: "Frankreich",
      nl: "Frankrijk",
    },
  },
  {
    code: "ga",
    name: {
      fr: "Gabon",
      en: "Gabon",
      es: "Gabon",
      ca: "Gabon",
      it: "Gabon",
      de: "Gabun",
      nl: "Gabun",
    },
  },
  {
    code: "gb",
    name: {
      fr: "Royaume-uni",
      en: "United Kingdom",
      es: "United Kingdom",
      ca: "United Kingdom",
      it: "Regno Unito",
      de: "Großbritannien",
      nl: "Großbritannien",
    },
  },
  {
    code: "gd",
    name: {
      fr: "Grenade",
      en: "Grenada",
      es: "Grenada",
      ca: "Grenada",
      it: "Grenada",
      de: "Grenada",
      nl: "Grenada",
    },
  },
  {
    code: "ge",
    name: {
      fr: "Géorgie",
      en: "Georgia",
      es: "Georgia",
      ca: "Georgia",
      it: "Georgia",
      de: "Georgien",
      nl: "Georgien",
    },
  },
  {
    code: "gf",
    name: {
      fr: "Guyane Française",
      en: "Guyane Française",
      es: "French Guiana",
      ca: "Guaiana Francesa",
      it: "Guyane Française",
      de: "French Guiana",
      nl: "Frans-Guyana",
    },
  },
  {
    code: "gh",
    name: {
      fr: "Ghana",
      en: "Ghana",
      es: "Ghana",
      ca: "Ghana",
      it: "Ghana",
      de: "Ghana",
      nl: "Ghana",
    },
  },
  {
    code: "gi",
    name: {
      fr: "Gibraltar",
      en: "Gibraltar",
      es: "Gibraltar",
      ca: "Gibraltar",
      it: "Gibraltar",
      de: "Gibraltar",
      nl: "Gibraltar",
    },
  },
  {
    code: "gm",
    name: {
      fr: "Gambie",
      en: "Gambia",
      es: "Gambia",
      ca: "Gambia",
      it: "Gambia",
      de: "Gambia",
      nl: "Gambia",
    },
  },
  {
    code: "gn",
    name: {
      fr: "Guinée",
      en: "Guinea",
      es: "Guinea",
      ca: "Guinea",
      it: "Guinea",
      de: "Guinea",
      nl: "Guinea",
    },
  },
  {
    code: "gp",
    name: {
      fr: "Guadeloupe",
      en: "Guadeloupe",
      es: "Guadeloupe",
      ca: "Guadeloupe",
      it: "Guadalupa",
      de: "Guadeloupe",
      nl: "Guadeloupe",
    },
  },
  {
    code: "gq",
    name: {
      fr: "Guinée Equatoriale",
      en: "Equatorial Guinea",
      es: "Equatorial Guinea",
      ca: "Equatorial Guinea",
      it: "Guinea Equatoriale",
      de: "Aquatorial Guinea",
      nl: "Aquatorial Guinea",
    },
  },
  {
    code: "gr",
    name: {
      fr: "Grèce",
      en: "Greece",
      es: "Greece",
      ca: "Greece",
      it: "Grecia",
      de: "Griechenland",
      nl: "Griechenland",
    },
  },
  {
    code: "gt",
    name: {
      fr: "Guatemala",
      en: "Guatemala",
      es: "Guatemala",
      ca: "Guatemala",
      it: "Guatemala",
      de: "Guatemala",
      nl: "Guatemala",
    },
  },
  {
    code: "gu",
    name: {
      fr: "Guam",
      en: "Guam",
      es: "Guam",
      ca: "Guam",
      it: "Guam",
      de: "Guam",
      nl: "Guam",
    },
  },
  {
    code: "gw",
    name: {
      fr: "Guinée Bissau",
      en: "Guinea Bissau",
      es: "Guinea Bissau",
      ca: "Guinea Bissau",
      it: "Guinea Bissau",
      de: "Guinea Bissau",
      nl: "Guinea Bissau",
    },
  },
  {
    code: "gy",
    name: {
      fr: "Guyana",
      en: "Guyana",
      es: "Guyana",
      ca: "Guyana",
      it: "Guyana",
      de: "Guyana",
      nl: "Guyana",
    },
  },
  {
    code: "hk",
    name: {
      fr: "Hong Kong",
      en: "Hong Kong",
      es: "Hong Kong",
      ca: "Hong Kong",
      it: "Hong Kong",
      de: "Hong Kong",
      nl: "Hong Kong",
    },
  },
  {
    code: "hn",
    name: {
      fr: "Honduras",
      en: "Honduras",
      es: "Honduras",
      ca: "Honduras",
      it: "Honduras",
      de: "Honduras",
      nl: "Honduras",
    },
  },
  {
    code: "hr",
    name: {
      fr: "Croatie",
      en: "Croatia",
      es: "Croatia",
      ca: "Croatia",
      it: "Croazia",
      de: "Kroatien",
      nl: "Kroatien",
    },
  },
  {
    code: "ht",
    name: {
      fr: "Haïti",
      en: "Haïti",
      es: "Haïti",
      ca: "Haïti",
      it: "Haïti",
      de: "Haiti",
      nl: "Haiti",
    },
  },
  {
    code: "hu",
    name: {
      fr: "Hongrie",
      en: "Hungary",
      es: "Hungary",
      ca: "Hungary",
      it: "Ungheria",
      de: "Ungarn",
      nl: "Ungarn",
    },
  },
  {
    code: "id",
    name: {
      fr: "Indonésie",
      en: "Indonesia",
      es: "Indonesia",
      ca: "Indonesia",
      it: "Indonesia",
      de: "Indonesien",
      nl: "Indonesien",
    },
  },
  {
    code: "ie",
    name: {
      fr: "Irlande",
      en: "Ireland",
      es: "Ireland",
      ca: "Ireland",
      it: "Irlanda",
      de: "Irland",
      nl: "Irland",
    },
  },
  {
    code: "il",
    name: {
      fr: "Israël",
      en: "Israel",
      es: "Israel",
      ca: "Israel",
      it: "Israele",
      de: "Israel",
      nl: "Israel",
    },
  },
  {
    code: "in",
    name: {
      fr: "Inde",
      en: "India",
      es: "India",
      ca: "India",
      it: "India",
      de: "Indien",
      nl: "Indien",
    },
  },
  {
    code: "io",
    name: {
      fr: "BIOT (British Indian Ocean Territories)",
      en: "British Indian Ocean Territories",
      es: "British Indian Ocean Territories",
      ca: "British Indian Ocean Territories",
      it: "Territori britannici dell'Oceano Indiano",
      de: "British Indian Ocean Territories",
      nl: "British Indian Ocean Territories",
    },
  },
  {
    code: "iq",
    name: {
      fr: "Irak",
      en: "Iraq",
      es: "Iraq",
      ca: "Iraq",
      it: "Iraq",
      de: "Irak",
      nl: "Irak",
    },
  },
  {
    code: "ir",
    name: {
      fr: "Iran",
      en: "Iran",
      es: "Iran",
      ca: "Iran",
      it: "Iran",
      de: "Iran",
      nl: "Iran",
    },
  },
  {
    code: "is",
    name: {
      fr: "Islande",
      en: "Iceland",
      es: "Iceland",
      ca: "Iceland",
      it: "Islanda",
      de: "Island",
      nl: "Island",
    },
  },
  {
    code: "it",
    name: {
      fr: "Italie",
      en: "Italy",
      es: "Italy",
      ca: "Italy",
      it: "Italia",
      de: "Italien",
      nl: "Italien",
    },
  },
  {
    code: "jm",
    name: {
      fr: "Jamaïque",
      en: "Jamaica",
      es: "Jamaica",
      ca: "Jamaica",
      it: "Giamaica",
      de: "Jamaika",
      nl: "Jamaika",
    },
  },
  {
    code: "jo",
    name: {
      fr: "Jordanie",
      en: "Jordan",
      es: "Jordan",
      ca: "Jordan",
      it: "Jordan",
      de: "Jordanien",
      nl: "Jordanien",
    },
  },
  {
    code: "jp",
    name: {
      fr: "Japon",
      en: "Japan",
      es: "Japan",
      ca: "Japan",
      it: "Giappone",
      de: "Japan",
      nl: "Japan",
    },
  },
  {
    code: "ke",
    name: {
      fr: "Kénya",
      en: "Kenya",
      es: "Kenya",
      ca: "Kenya",
      it: "Kenya",
      de: "Kenia",
      nl: "Kenia",
    },
  },
  {
    code: "kg",
    name: {
      fr: "Kirghizistan",
      en: "Kyrgyzstan",
      es: "Kyrgyzstan",
      ca: "Kyrgyzstan",
      it: "Kirghizistan",
      de: "Kirgistan",
      nl: "Kirgistan",
    },
  },
  {
    code: "kh",
    name: {
      fr: "Cambodge",
      en: "Cambodia",
      es: "Cambodia",
      ca: "Cambodia",
      it: "Cambogia",
      de: "Kambodscha",
      nl: "Kambodscha",
    },
  },
  {
    code: "ki",
    name: {
      fr: "Kiribati",
      en: "Kiribati",
      es: "Kiribati",
      ca: "Kiribati",
      it: "Kiribati",
      de: "Kiribati",
      nl: "Kiribati",
    },
  },
  {
    code: "km",
    name: {
      fr: "Comores",
      en: "Comoros",
      es: "Comoros",
      ca: "Comoros",
      it: "Comore",
      de: "Komoren",
      nl: "Komoren",
    },
  },
  {
    code: "kn",
    name: {
      fr: "Saint-Kitts et Nevis",
      en: "Saint Kitts and Nevis",
      es: "Saint Kitts and Nevis",
      ca: "Saint Kitts and Nevis",
      it: "Saint Kitts e Nevis",
      de: "Saint Kitts und Nevis",
      nl: "Saint Kitts und Nevis",
    },
  },
  {
    code: "kp",
    name: {
      fr: "Corée du Nord",
      en: "North Korea",
      es: "North Korea",
      ca: "North Korea",
      it: "Corea del Nord",
      de: "Corea, Dem. VR",
      nl: "Corea, Dem. VR",
    },
  },
  {
    code: "kr",
    name: {
      fr: "Corée du Sud",
      en: "South Korea",
      es: "South Korea",
      ca: "South Korea",
      it: "Corea del Sud",
      de: "Corea, Republik",
      nl: "Corea, Republik",
    },
  },
  {
    code: "kw",
    name: {
      fr: "Koweit",
      en: "Kuwait",
      es: "Kuwait",
      ca: "Kuwait",
      it: "Kuwait",
      de: "Kuwait",
      nl: "Kuwait",
    },
  },
  {
    code: "ky",
    name: {
      fr: "Cayman (Iles)",
      en: "Cayman Islands",
      es: "Cayman Islands",
      ca: "Cayman Islands",
      it: "Isole Cayman",
      de: "Cayman Inseln",
      nl: "Cayman Inseln",
    },
  },
  {
    code: "kz",
    name: {
      fr: "Kazakhstan",
      en: "Kazakhstan",
      es: "Kazakhstan",
      ca: "Kazakhstan",
      it: "Kazakhstan",
      de: "Kasachstan",
      nl: "Kasachstan",
    },
  },
  {
    code: "la",
    name: {
      fr: "Laos",
      en: "Laos",
      es: "Laos",
      ca: "Laos",
      it: "Laos",
      de: "Laos",
      nl: "Laos",
    },
  },
  {
    code: "lb",
    name: {
      fr: "Liban",
      en: "Lebanon",
      es: "Lebanon",
      ca: "Lebanon",
      it: "Libano",
      de: "Libanon",
      nl: "Libanon",
    },
  },
  {
    code: "lc",
    name: {
      fr: "Sainte-Lucie",
      en: "Saint-Lucia",
      es: "Saint-Lucia",
      ca: "Saint-Lucia",
      it: "Saint-Lucia",
      de: "Saint-Lucia",
      nl: "Saint-Lucia",
    },
  },
  {
    code: "li",
    name: {
      fr: "Liechtenstein",
      en: "Liechtenstein",
      es: "Liechtenstein",
      ca: "Liechtenstein",
      it: "Liechtenstein",
      de: "Liechtenstein",
      nl: "Liechtenstein",
    },
  },
  {
    code: "lk",
    name: {
      fr: "Sri Lanka",
      en: "Sri Lanka",
      es: "Sri Lanka",
      ca: "Sri Lanka",
      it: "Sri Lanka",
      de: "Sri Lanka",
      nl: "Sri Lanka",
    },
  },
  {
    code: "lr",
    name: {
      fr: "Libéria",
      en: "Liberia",
      es: "Liberia",
      ca: "Liberia",
      it: "Liberia",
      de: "Liberia",
      nl: "Liberia",
    },
  },
  {
    code: "ls",
    name: {
      fr: "Lesotho",
      en: "Lesotho",
      es: "Lesotho",
      ca: "Lesotho",
      it: "Lesotho",
      de: "Lesotho",
      nl: "Lesotho",
    },
  },
  {
    code: "lt",
    name: {
      fr: "Lituanie",
      en: "Lithuania",
      es: "Lithuania",
      ca: "Lithuania",
      it: "Lituania",
      de: "Litauen",
      nl: "Litauen",
    },
  },
  {
    code: "lu",
    name: {
      fr: "Luxembourg",
      en: "Luxembourg",
      es: "Luxembourg",
      ca: "Luxembourg",
      it: "Lussemburgo",
      de: "Luxemburg",
      nl: "Luxemburg",
    },
  },
  {
    code: "lv",
    name: {
      fr: "Lettonie",
      en: "Latvia",
      es: "Latvia",
      ca: "Latvia",
      it: "Lettonia",
      de: "Lettland",
      nl: "Lettland",
    },
  },
  {
    code: "ly",
    name: {
      fr: "Libye",
      en: "Libya",
      es: "Libya",
      ca: "Libya",
      it: "Libia",
      de: "Libyen",
      nl: "Libyen",
    },
  },
  {
    code: "ma",
    name: {
      fr: "Maroc",
      en: "Morocco",
      es: "Morocco",
      ca: "Morocco",
      it: "Marocco",
      de: "Marokko",
      nl: "Marokko",
    },
  },
  {
    code: "mc",
    name: {
      fr: "Monaco",
      en: "Monaco",
      es: "Monaco",
      ca: "Monaco",
      it: "Monaco",
      de: "Monaco",
      nl: "Monaco",
    },
  },
  {
    code: "md",
    name: {
      fr: "Moldavie",
      en: "Moldova",
      es: "Moldova",
      ca: "Moldova",
      it: "Moldavia",
      de: "Moldawien",
      nl: "Moldawien",
    },
  },
  {
    code: "mg",
    name: {
      fr: "Madagascar",
      en: "Madagascar",
      es: "Madagascar",
      ca: "Madagascar",
      it: "Madagascar",
      de: "Madagaskar",
      nl: "Madagaskar",
    },
  },
  {
    code: "mh",
    name: {
      fr: "Marshall (Iles)",
      en: "Marshall Islands",
      es: "Marshall Islands",
      ca: "Marshall Islands",
      it: "Isole Marshall",
      de: "Marshall Inseln",
      nl: "Marshall Inseln",
    },
  },
  {
    code: "mk",
    name: {
      fr: "Macedoine",
      en: "Macedonia",
      es: "Macedonia",
      ca: "Macedonia",
      it: "Macedonia",
      de: "Mazedonien",
      nl: "Mazedonien",
    },
  },
  {
    code: "ml",
    name: {
      fr: "Mali",
      en: "Mali",
      es: "Mali",
      ca: "Mali",
      it: "Mali",
      de: "Mali",
      nl: "Mali",
    },
  },
  {
    code: "mm",
    name: {
      fr: "Myanmar",
      en: "Myanmar",
      es: "Myanmar",
      ca: "Myanmar",
      it: "Myanmar",
      de: "Burma",
      nl: "Burma",
    },
  },
  {
    code: "mn",
    name: {
      fr: "Mongolie",
      en: "Mongolia",
      es: "Mongolia",
      ca: "Mongolia",
      it: "Mongolia",
      de: "Mongolei",
      nl: "Mongolei",
    },
  },
  {
    code: "mp",
    name: {
      fr: "Mariannes du Nord (Iles)",
      en: "Saipan",
      es: "Saipan",
      ca: "Saipan",
      it: "Saipan",
      de: "Mariannes-Inseln des Nordens",
      nl: "Mariannes-Inseln des Nordens",
    },
  },
  {
    code: "mq",
    name: {
      fr: "Martinique",
      en: "Martinique",
      es: "Martinique",
      ca: "Martinica",
      it: "Martinica",
      de: "Martinique",
      nl: "Martinique",
    },
  },
  {
    code: "mr",
    name: {
      fr: "Mauritanie",
      en: "Mauritania",
      es: "Mauritania",
      ca: "Mauritania",
      it: "Mauritania",
      de: "Mauritanien",
      nl: "Mauritanien",
    },
  },
  {
    code: "ms",
    name: {
      fr: "Montserrat",
      en: "Montserrat",
      es: "Montserrat",
      ca: "Montserrat",
      it: "Montserrat",
      de: "Montserrat",
      nl: "Montserrat",
    },
  },
  {
    code: "mt",
    name: {
      fr: "Malte",
      en: "Malta",
      es: "Malta",
      ca: "Malta",
      it: "Malta",
      de: "Malta",
      nl: "Malta",
    },
  },
  {
    code: "mu",
    name: {
      fr: "Maurice",
      en: "Mauritius",
      es: "Mauritius",
      ca: "Mauritius",
      it: "Mauritius",
      de: "Mauritius",
      nl: "Mauritius",
    },
  },
  {
    code: "mv",
    name: {
      fr: "Maldives",
      en: "Maldives",
      es: "Maldives",
      ca: "Maldives",
      it: "Maldive",
      de: "Malediven",
      nl: "Malediven",
    },
  },
  {
    code: "mw",
    name: {
      fr: "Malawi",
      en: "Malawi",
      es: "Malawi",
      ca: "Malawi",
      it: "Malawi",
      de: "Malawi",
      nl: "Malawi",
    },
  },
  {
    code: "mx",
    name: {
      fr: "Mexique",
      en: "Mexico",
      es: "Mexico",
      ca: "Mexico",
      it: "Messico",
      de: "Mexiko",
      nl: "Mexiko",
    },
  },
  {
    code: "my",
    name: {
      fr: "Malaisie",
      en: "Malaysia",
      es: "Malaysia",
      ca: "Malaysia",
      it: "Malesia",
      de: "Malaysia",
      nl: "Malaysia",
    },
  },
  {
    code: "mz",
    name: {
      fr: "Mozambique",
      en: "Mozambique",
      es: "Mozambique",
      ca: "Mozambique",
      it: "Mozambico",
      de: "Mosambik",
      nl: "Mosambik",
    },
  },
  {
    code: "na",
    name: {
      fr: "Namibie",
      en: "Namibia",
      es: "Namibia",
      ca: "Namibia",
      it: "Namibia",
      de: "Namibia",
      nl: "Namibia",
    },
  },
  {
    code: "nc",
    name: {
      fr: "Nouvelle-Calédonie",
      en: "New Caledonia",
      es: "New Caledonia",
      ca: "Nova Caledònia",
      it: "Nuova Caledonia",
      de: "New Caledonia",
      nl: "Nieuw-Caledonië",
    },
  },
  {
    code: "ne",
    name: {
      fr: "Niger",
      en: "Niger",
      es: "Niger",
      ca: "Niger",
      it: "Niger",
      de: "Niger",
      nl: "Niger",
    },
  },
  {
    code: "nf",
    name: {
      fr: "Norfolk",
      en: "Norfolk",
      es: "Norfolk",
      ca: "Norfolk",
      it: "Norfolk",
      de: "Norfolk",
      nl: "Norfolk",
    },
  },
  {
    code: "ng",
    name: {
      fr: "Nigeria",
      en: "Nigeria",
      es: "Nigeria",
      ca: "Nigeria",
      it: "Nigeria",
      de: "Nigeria",
      nl: "Nigeria",
    },
  },
  {
    code: "ni",
    name: {
      fr: "Nicaragua",
      en: "Nicaragua",
      es: "Nicaragua",
      ca: "Nicaragua",
      it: "Nicaragua",
      de: "Nicaragua",
      nl: "Nicaragua",
    },
  },
  {
    code: "nl",
    name: {
      fr: "Pays-Bas",
      en: "Netherlands",
      es: "Netherlands",
      ca: "Netherlands",
      it: "Olanda",
      de: "Niederlande",
      nl: "Nederland",
    },
  },
  {
    code: "no",
    name: {
      fr: "Norvège",
      en: "Norway",
      es: "Norway",
      ca: "Norway",
      it: "Norvegia",
      de: "Norwegen",
      nl: "Norwegen",
    },
  },
  {
    code: "np",
    name: {
      fr: "Népal",
      en: "Nepal",
      es: "Nepal",
      ca: "Nepal",
      it: "Nepal",
      de: "Nepal",
      nl: "Nepal",
    },
  },
  {
    code: "nr",
    name: {
      fr: "Nauru",
      en: "Nauru",
      es: "Nauru",
      ca: "Nauru",
      it: "Nauru",
      de: "Nauru",
      nl: "Nauru",
    },
  },
  {
    code: "nu",
    name: {
      fr: "Niue",
      en: "Niue",
      es: "Niue",
      ca: "Niue",
      it: "Niue",
      de: "Niue",
      nl: "Niue",
    },
  },
  {
    code: "nz",
    name: {
      fr: "Nouvelle Zélande",
      en: "New Zealand",
      es: "New Zealand",
      ca: "New Zealand",
      it: "Nuova Zelanda",
      de: "Neuseeland",
      nl: "Neuseeland",
    },
  },
  {
    code: "om",
    name: {
      fr: "Oman",
      en: "Oman",
      es: "Oman",
      ca: "Oman",
      it: "Oman",
      de: "Oman",
      nl: "Oman",
    },
  },
  {
    code: "pa",
    name: {
      fr: "Panama",
      en: "Panama",
      es: "Panama",
      ca: "Panama",
      it: "Panama",
      de: "Panama",
      nl: "Panama",
    },
  },
  {
    code: "pe",
    name: {
      fr: "Pérou",
      en: "Peru",
      es: "Peru",
      ca: "Peru",
      it: "Perù",
      de: "Peru",
      nl: "Peru",
    },
  },
  {
    code: "pf",
    name: {
      fr: "Polynésie Française",
      en: "Polynésie Française",
      es: "French Polynesia",
      ca: "Polinèsia Francesa",
      it: "Polinesia Francese",
      de: "French Polynesia",
      nl: "Frans-Polynesië",
    },
  },
  {
    code: "pg",
    name: {
      fr: "Papouasie-Nouvelle Guinée",
      en: "Papua New Guinea",
      es: "Papua New Guinea",
      ca: "Papua New Guinea",
      it: "Papua Nuova Guinea",
      de: "Papua Neuguinea",
      nl: "Papua Neuguinea",
    },
  },
  {
    code: "ph",
    name: {
      fr: "Philippines",
      en: "Philippines",
      es: "Philippines",
      ca: "Philippines",
      it: "Filippine",
      de: "Philippinen",
      nl: "Philippinen",
    },
  },
  {
    code: "pk",
    name: {
      fr: "Pakistan",
      en: "Pakistan",
      es: "Pakistan",
      ca: "Pakistan",
      it: "Pakistan",
      de: "Pakistan",
      nl: "Pakistan",
    },
  },
  {
    code: "pl",
    name: {
      fr: "Pologne",
      en: "Poland",
      es: "Poland",
      ca: "Poland",
      it: "Polonia",
      de: "Polen",
      nl: "Polen",
    },
  },
  {
    code: "pm",
    name: {
      fr: "Saint-Pierre-Et-Miquelon",
      en: "Saint-Pierre-and-Miquelon",
      es: "Saint-Pierre-And-Miquelon",
      ca: "Saint-Pierre i Miquelon",
      it: "Saint-Pierre-e-Miquelon",
      de: "Saint-Pierre-And-Miquelon",
      nl: "Saint-Pierre en Miquelon",
    },
  },
  {
    code: "ps",
    name: {
      fr: "Palestine",
      en: "Palestine",
      es: "Palestine",
      ca: "Palestine",
      it: "Palestina",
      de: "Palästina",
      nl: "Palästina",
    },
  },
  {
    code: "pt",
    name: {
      fr: "Portugal",
      en: "Portugal",
      es: "Portugal",
      ca: "Portugal",
      it: "Portogallo",
      de: "Portugal",
      nl: "Portugal",
    },
  },
  {
    code: "py",
    name: {
      fr: "Paraguay",
      en: "Paraguay",
      es: "Paraguay",
      ca: "Paraguay",
      it: "Paraguay",
      de: "Paraguay",
      nl: "Paraguay",
    },
  },
  {
    code: "qa",
    name: {
      fr: "Qatar",
      en: "Qatar",
      es: "Qatar",
      ca: "Qatar",
      it: "Qatar",
      de: "Katar",
      nl: "Katar",
    },
  },
  {
    code: "re",
    name: {
      fr: "La Réunion",
      en: "La Réunion",
      es: "La Réunion",
      ca: "La Reunió",
      it: "Riunione (isola)",
      de: "La Réunion",
      nl: "La Réunion",
    },
  },
  {
    code: "ro",
    name: {
      fr: "Roumanie",
      en: "Romania",
      es: "Romania",
      ca: "Romania",
      it: "Romania",
      de: "Römanien",
      nl: "Römanien",
    },
  },
  {
    code: "rs",
    name: {
      fr: "Serbie et Monténégro",
      en: "Serbia and Montenegro",
      es: "Serbia and Montenegro",
      ca: "Serbia and Montenegro",
      it: "Serbia e Montenegro",
      de: "Siebien - Montenegro",
      nl: "Siebien - Montenegro",
    },
  },
  {
    code: "ru",
    name: {
      fr: "Russie",
      en: "Russia",
      es: "Russia",
      ca: "Russia",
      it: "Russia",
      de: "Rußland",
      nl: "Rußland",
    },
  },
  {
    code: "rw",
    name: {
      fr: "Rwanda",
      en: "Rwanda",
      es: "Rwanda",
      ca: "Rwanda",
      it: "Ruanda",
      de: "Ruanda",
      nl: "Ruanda",
    },
  },
  {
    code: "sa",
    name: {
      fr: "Arabie Saoudite",
      en: "Saudi Arabia",
      es: "Saudi Arabia",
      ca: "Saudi Arabia",
      it: "Arabia Saudita",
      de: "Saudi Arabien",
      nl: "Saudi Arabien",
    },
  },
  {
    code: "sb",
    name: {
      fr: "Salomon",
      en: "Salomon",
      es: "Salomon",
      ca: "Salomon",
      it: "Salomon",
      de: "Solomon-Inseln",
      nl: "Solomon-Inseln",
    },
  },
  {
    code: "sc",
    name: {
      fr: "Seychelles",
      en: "Seychelles",
      es: "Seychelles",
      ca: "Seychelles",
      it: "Seychelles",
      de: "Seychellen",
      nl: "Seychellen",
    },
  },
  {
    code: "sd",
    name: {
      fr: "Soudan",
      en: "Sudan",
      es: "Sudan",
      ca: "Sudan",
      it: "Sudan",
      de: "Sudan",
      nl: "Sudan",
    },
  },
  {
    code: "se",
    name: {
      fr: "Suède",
      en: "Sweden",
      es: "Sweden",
      ca: "Sweden",
      it: "Svezia",
      de: "Schweden",
      nl: "Schweden",
    },
  },
  {
    code: "sg",
    name: {
      fr: "Singapour",
      en: "Singapore",
      es: "Singapore",
      ca: "Singapore",
      it: "Singapore",
      de: "Singapur",
      nl: "Singapur",
    },
  },
  {
    code: "sh",
    name: {
      fr: "Sainte-Hélène",
      en: "Saint-Helena",
      es: "Saint-Helena",
      ca: "Saint-Helena",
      it: "Saint-Helena",
      de: "Saint-Helena",
      nl: "Saint-Helena",
    },
  },
  {
    code: "si",
    name: {
      fr: "Slovénie",
      en: "Slovenia",
      es: "Slovenia",
      ca: "Slovenia",
      it: "Slovenia",
      de: "Slowenien",
      nl: "Slowenien",
    },
  },
  {
    code: "sk",
    name: {
      fr: "Slovaquie",
      en: "Slovakia",
      es: "Slovakia",
      ca: "Slovakia",
      it: "Slovacchia",
      de: "Slowakische Republik",
      nl: "Slowakische Republik",
    },
  },
  {
    code: "sl",
    name: {
      fr: "Sierra Leone",
      en: "Sierra Leone",
      es: "Sierra Leone",
      ca: "Sierra Leone",
      it: "Sierra Leone",
      de: "Sierra Leone",
      nl: "Sierra Leone",
    },
  },
  {
    code: "sm",
    name: {
      fr: "Saint-Marin",
      en: "San Marino",
      es: "San Marino",
      ca: "San Marino",
      it: "San Marino",
      de: "San Marino",
      nl: "San Marino",
    },
  },
  {
    code: "sn",
    name: {
      fr: "Sénégal",
      en: "Senegal",
      es: "Senegal",
      ca: "Senegal",
      it: "Senegal",
      de: "Senegal",
      nl: "Senegal",
    },
  },
  {
    code: "so",
    name: {
      fr: "Somalie",
      en: "Somalia",
      es: "Somalia",
      ca: "Somalia",
      it: "Somalia",
      de: "Somalia",
      nl: "Somalia",
    },
  },
  {
    code: "sr",
    name: {
      fr: "Surinam",
      en: "Suriname",
      es: "Suriname",
      ca: "Suriname",
      it: "Suriname",
      de: "Suriname",
      nl: "Suriname",
    },
  },
  {
    code: "st",
    name: {
      fr: "Sao Tome et Principe",
      en: "Sao Tome and Principe",
      es: "Sao Tome and Principe",
      ca: "Sao Tome and Principe",
      it: "Sao Tomé e Principe",
      de: "Sao Tome",
      nl: "Sao Tome",
    },
  },
  {
    code: "sv",
    name: {
      fr: "El Salvador",
      en: "El Salvador",
      es: "El Salvador",
      ca: "El Salvador",
      it: "El Salvador",
      de: "El Salvador",
      nl: "El Salvador",
    },
  },
  {
    code: "sy",
    name: {
      fr: "Syrie",
      en: "Syria",
      es: "Syria",
      ca: "Syria",
      it: "Siria",
      de: "Syrien",
      nl: "Syrien",
    },
  },
  {
    code: "sz",
    name: {
      fr: "Swaziland",
      en: "Swaziland",
      es: "Swaziland",
      ca: "Swaziland",
      it: "Swaziland",
      de: "Swaziland",
      nl: "Swaziland",
    },
  },
  {
    code: "tc",
    name: {
      fr: "Turques et Caïques (Iles)",
      en: "Turks and Caicos Islands",
      es: "Turks and Caicos Islands",
      ca: "Turks and Caicos Islands",
      it: "Isole Turks e Caicos",
      de: "Turks und Caicos-Inseln",
      nl: "Turks und Caicos-Inseln",
    },
  },
  {
    code: "td",
    name: {
      fr: "Tchad",
      en: "Chad",
      es: "Chad",
      ca: "Chad",
      it: "Chad",
      de: "Tschad",
      nl: "Tschad",
    },
  },
  {
    code: "tg",
    name: {
      fr: "Togo",
      en: "Togo",
      es: "Togo",
      ca: "Togo",
      it: "Togo",
      de: "Togo",
      nl: "Togo",
    },
  },
  {
    code: "th",
    name: {
      fr: "Thaïlande",
      en: "Thailand",
      es: "Thailand",
      ca: "Thailand",
      it: "Thailandia",
      de: "Thailand",
      nl: "Thailand",
    },
  },
  {
    code: "tj",
    name: {
      fr: "Tadjikistan",
      en: "Tajikistan",
      es: "Tajikistan",
      ca: "Tajikistan",
      it: "Tagikistan",
      de: "Tadjikistan",
      nl: "Tadjikistan",
    },
  },
  {
    code: "tk",
    name: {
      fr: "Tokelau",
      en: "Tokelau",
      es: "Tokelau",
      ca: "Tokelau",
      it: "Tokelau",
      de: "Tokelau",
      nl: "Tokelau",
    },
  },
  {
    code: "tl",
    name: {
      fr: "Timor Oriental",
      en: "East-Timor",
      es: "East-Timor",
      ca: "East-Timor",
      it: "East-Timor",
      de: "Ost-Timor",
      nl: "Ost-Timor",
    },
  },
  {
    code: "tm",
    name: {
      fr: "Turkménistan",
      en: "Turkmenistan",
      es: "Turkmenistan",
      ca: "Turkmenistan",
      it: "Turkmenistan",
      de: "Turkmenistan",
      nl: "Turkmenistan",
    },
  },
  {
    code: "tn",
    name: {
      fr: "Tunisie",
      en: "Tunisia",
      es: "Tunisia",
      ca: "Tunisia",
      it: "Tunisia",
      de: "Tunesien",
      nl: "Tunesien",
    },
  },
  {
    code: "to",
    name: {
      fr: "Tonka",
      en: "Tonga",
      es: "Tonga",
      ca: "Tonga",
      it: "Tonga",
      de: "Tonga",
      nl: "Tonga",
    },
  },
  {
    code: "tr",
    name: {
      fr: "Turquie",
      en: "Turkey",
      es: "Turkey",
      ca: "Turkey",
      it: "Turchia",
      de: "Türkei",
      nl: "Türkei",
    },
  },
  {
    code: "tt",
    name: {
      fr: "Trinidad et Tobago",
      en: "Trinidad and Tobago",
      es: "Trinidad and Tobago",
      ca: "Trinidad and Tobago",
      it: "Trinidad e Tobago",
      de: "Trinidad und Tobago",
      nl: "Trinidad und Tobago",
    },
  },
  {
    code: "tv",
    name: {
      fr: "Tuvalu",
      en: "Tuvalu",
      es: "Tuvalu",
      ca: "Tuvalu",
      it: "Tuvalu",
      de: "Tuvalu",
      nl: "Tuvalu",
    },
  },
  {
    code: "tw",
    name: {
      fr: "Taïwan",
      en: "Taiwan",
      es: "Taiwan",
      ca: "Taiwan",
      it: "Taiwan",
      de: "Taiwan",
      nl: "Taiwan",
    },
  },
  {
    code: "tz",
    name: {
      fr: "Tanzanie",
      en: "Tanzania",
      es: "Tanzania",
      ca: "Tanzania",
      it: "Tanzania",
      de: "Tansania",
      nl: "Tansania",
    },
  },
  {
    code: "ua",
    name: {
      fr: "Ukraine",
      en: "Ukraine",
      es: "Ukraine",
      ca: "Ukraine",
      it: "Ucraina",
      de: "Ukranien",
      nl: "Ukranien",
    },
  },
  {
    code: "ug",
    name: {
      fr: "Ouganda",
      en: "Uganda",
      es: "Uganda",
      ca: "Uganda",
      it: "Uganda",
      de: "Uganda",
      nl: "Uganda",
    },
  },
  {
    code: "us",
    name: {
      fr: "Etats-Unis d'Amérique",
      en: "U.S.A",
      es: "U.S.A",
      ca: "U.S.A",
      it: "U.S.A",
      de: "Vereinigte Staaten",
      nl: "Vereinigte Staaten",
    },
  },
  {
    code: "uy",
    name: {
      fr: "Uruguay",
      en: "Uruguay",
      es: "Uruguay",
      ca: "Uruguay",
      it: "Uruguay",
      de: "Uruguay",
      nl: "Uruguay",
    },
  },
  {
    code: "uz",
    name: {
      fr: "Ouzbékistan",
      en: "Uzbekistan",
      es: "Uzbekistan",
      ca: "Uzbekistan",
      it: "Uzbekistan",
      de: "Usbekistan",
      nl: "Usbekistan",
    },
  },
  {
    code: "va",
    name: {
      fr: "Vatican",
      en: "Vatican",
      es: "Vatican",
      ca: "Vatican",
      it: "Vaticano",
      de: "Vatikan",
      nl: "Vatikan",
    },
  },
  {
    code: "vc",
    name: {
      fr: "Saint-Vincent et Grenadines",
      en: "Saint-Vincent and Grenadines",
      es: "Saint-Vincent and Grenadines",
      ca: "Saint-Vincent and Grenadines",
      it: "Saint-Vincent e Grenadines",
      de: "Saint-Vincent Grenadinen",
      nl: "Saint-Vincent Grenadinen",
    },
  },
  {
    code: "ve",
    name: {
      fr: "Vénézuela",
      en: "Venezuela",
      es: "Venezuela",
      ca: "Venezuela",
      it: "Venezuela",
      de: "Venezuela",
      nl: "Venezuela",
    },
  },
  {
    code: "vg",
    name: {
      fr: "Vierges Britanniques (Iles)",
      en: "British Virgin Islands",
      es: "British Virgin Islands",
      ca: "British Virgin Islands",
      it: "Isole Vergini Britanniche",
      de: "British Virgin Islands",
      nl: "British Virgin Islands",
    },
  },
  {
    code: "vi",
    name: {
      fr: "Vierges Américaines (Iles)",
      en: "United States Virgin Islands",
      es: "United States Virgin Islands",
      ca: "United States Virgin Islands",
      it: "Stati Uniti Isole Vergini",
      de: "United States Virgin Islands",
      nl: "United States Virgin Islands",
    },
  },
  {
    code: "vn",
    name: {
      fr: "Vietnam",
      en: "Vietnam",
      es: "Vietnam",
      ca: "Vietnam",
      it: "Vietnam",
      de: "Vietnam",
      nl: "Vietnam",
    },
  },
  {
    code: "vu",
    name: {
      fr: "Vanuatu",
      en: "Vanuatu",
      es: "Vanuatu",
      ca: "Vanuatu",
      it: "Vanuatu",
      de: "Vanuatu",
      nl: "Vanuatu",
    },
  },
  {
    code: "wf",
    name: {
      fr: "Wallis et Futuna",
      en: "Wallis And Futuna",
      es: "Wallis And Futuna",
      ca: "Wallis i Futuna",
      it: "Wallis E Futuna",
      de: "Wallis And Futuna",
      nl: "Wallis en Futuna",
    },
  },
  {
    code: "ws",
    name: {
      fr: "Samoa Occidentales",
      en: "Western Samoa",
      es: "Western Samoa",
      ca: "Western Samoa",
      it: "Western Samoa",
      de: "Western-Samoa",
      nl: "Western-Samoa",
    },
  },
  {
    code: "ye",
    name: {
      fr: "Yémen",
      en: "Yemen",
      es: "Yemen",
      ca: "Yemen",
      it: "Yemen",
      de: "Jemen",
      nl: "Jemen",
    },
  },
  {
    code: "yt",
    name: {
      fr: "Mayotte",
      en: "Mayotte",
      es: "Mayotte",
      ca: "Mayotte",
      it: "Mayotte",
      de: "Mayotte",
      nl: "Mayotte",
    },
  },
  {
    code: "za",
    name: {
      fr: "République d'Afrique du Sud",
      en: "South Africa Republic",
      es: "South Africa Republic",
      ca: "South Africa Republic",
      it: "Sud Africa Repubblica",
      de: "Südafrika Republik",
      nl: "Südafrika Republik",
    },
  },
  {
    code: "zm",
    name: {
      fr: "Zambie",
      en: "Zambia",
      es: "Zambia",
      ca: "Zambia",
      it: "Zambia",
      de: "Sambia",
      nl: "Sambia",
    },
  },
  {
    code: "zw",
    name: {
      fr: "Zimbabwe",
      en: "Zimbabwe",
      es: "Zimbabwe",
      ca: "Zimbabwe",
      it: "Zimbabwe",
      de: "Simbabwe",
      nl: "Simbabwe",
    },
  },
];

export default COUNTRIES;